import { AbstractControl, UntypedFormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import * as _ from 'lodash';

// @dynamic
export class MyValidator {
  static minLength(minLength: number): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (c.value && !isNaN(c.value)) {
        const strMinLength: string = c.value.toString();
        if (strMinLength.length < minLength) {
          return { minlength: true };
        }
      }
      return null;
    };
  }

  static maxLength(maxLength: number): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (c.value && !isNaN(c.value)) {
        const strMaxLength = c.value.toString();
        if (strMaxLength.length > maxLength) {
          return { maxLength: true };
        }
      }
      return null;
    };
  }

  static spaceCharacters(control: AbstractControl): ValidationErrors | null {
    if (control.value.indexOf(' ') >= 0) return { spaceCharacters: true };

    return null;
  }

  static email(control: AbstractControl): ValidationErrors | null {
    if (Validators.required(control)) {
      return null;
    }
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/.test(
      control.value
    )
      ? null
      : { email: true };
  }

  static requiredFileType(
    ...types: string[]
  ): (control: UntypedFormControl) => { requiredFileType: { requiredTypes: string[] } } {
    if (!types || types.length === 0) {
      return null;
    }

    return (control: UntypedFormControl) => {
      const files: File[] = control.value ? control.value : [];
      if (files) {
        for (const file of files) {
          const separatedName = file.name.split('.') as string[];
          const extension = separatedName[separatedName.length - 1].toLowerCase();
          if (!types.some(t => t === extension)) {
            return {
              requiredFileType: {
                requiredTypes: types,
              },
            };
          }
        }
        return null;
      }

      return null;
    };
  }

  static multipleOfNumber(num: number): ValidatorFn {
    return (control: UntypedFormControl): ValidationErrors | null => {
      if (Validators.required(control)) {
        return null;
      }

      if (num === 0) {
        return null;
      }

      const value = +control.value;
      if (!_.isNumber(value) || value % num > 0) {
        return {
          multipleOfNumber: {
            value: value,
            number: num,
          },
        };
      }

      return null;
    };
  }

  static autocompleteObjectValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value && typeof control.value === 'string' ? { noObject: { value: control.value } } : null;
    };
  }

  static maxFileSize(
    bytes: number
  ): (control: UntypedFormControl) => { maxFileSize: { max: number; current: number; filename: string } } {
    if (!bytes || bytes <= 0) {
      return null;
    }

    return (control: UntypedFormControl) => {
      const files: File[] = control.value ? control.value : [];
      if (files) {
        for (const file of files) {
          if (file.size > bytes) {
            return { maxFileSize: { max: bytes, current: file.size, filename: file.name } };
          }
        }
        return null;
      }

      return null;
    };
  }
}
